// extracted by mini-css-extract-plugin
export default {"frame":"YouTubeModal_frame__zFgDt"};